import { Map } from 'immutable';

import WorkspaceItemComments from 'Shared/constants/WorkspaceItemComments.constants';

class WorkspaceItemCommentHelper {
  static getUuid(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.UUID);
  }

  static getCreatedAt(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.CREATED_AT);
  }

  static getAuthorId(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.AUTHOR_ID);
  }

  static getWorkspaceItemId(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.WORKSPACE_ITEM_ID);
  }

  static getMeetingModeSessionId(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.MEETING_MODE_SESSION_ID);
  }

  static getBody(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.BODY, '');
  }

  static getBodyRawText(workspaceItemComment) {
    if (!Map.isMap(workspaceItemComment)) {
      return false;
    }
    return workspaceItemComment.get(WorkspaceItemComments.Model.BODY_RAW_TEXT);
  }
}

export default WorkspaceItemCommentHelper;
